/* eslint-disable @typescript-eslint/no-unused-vars */
import { AnalyticEvent, AnalyticTracking } from '@core/entity/analytics/analytic-tracking';

// A no-operation implementation of AnalyticTracking for environments where analytics is disabled.
// -----
export class NoOpAnalyticService implements AnalyticTracking {
  trackPageView(_pageTitle: string, _url: string): void {
    // No operation performed
    // console.log(`NoOpAnalyticService: trackPageView called with title=${pageTitle}, url=${url}`);
  }

  trackEvent(_config: AnalyticEvent): void {
    // No operation performed
    // console.log(
    //   `NoOpAnalyticService: trackEvent called with category=${category}, action=${action}, name=${name}, value=${value}`,
    // );
  }

  setUserId(_userId: string): void {
    // No operation performed
    // console.log(`NoOpAnalyticService: setUserId called with userId=${userId}`);
  }
}
